import HistoryModal from 'components/molecules/HistoryModal';
import PdfModal from 'components/molecules/PdfModal';
import TreeModal from 'components/molecules/TreeModal';
import Button from 'components/atoms/Button';
import Pdf from 'components/atoms/Pdf';
import { GlobalContext } from 'Context/GlobalContext/AppContext';
import fileSaver from 'file-saver';
import { useContext, useEffect, useState } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router';
import api from 'services/api';
import getKeyByValue from 'components/helpers/getKeyByValue';
import tipoDocEnum from 'pools/tipoDocEnum';
import './styles.scss';
import Loading from 'components/atoms/Loading';
import DOMPurify from 'dompurify';

const DetailPage = () => {
  const { setIsSmallHeader, setHistoryModal, setLoading, setResponseMsg, historyModal, pdfModal, treeModal, documents, setTreeModal } =
    useContext(GlobalContext);
  const { tipoDoc, id } = useParams();
  const navigate = useNavigate();
  const tipoDocId = getKeyByValue(tipoDocEnum, tipoDoc);
  const [document, setDocument] = useState(() => documents.find((doc) => doc.ID === parseInt(id) && doc.TipoDoc === parseInt(tipoDocId)));

  function handleHistory() {
    setHistoryModal({ isVisible: true, norma: document });
  }

  //Convert byte array stream to pdf file
  async function handleDownload() {
    try {
      const { data } = await api.getArquivo(document.ID, document.TipoDoc, false);
      const blob = new File([data], { type: 'application/pdf' });
      fileSaver.saveAs(blob, document.NomeArquivo);
    } catch (error) {
      console.error(error.message);
    }
  }

  function handleTreeView() {
    setTreeModal({ isVisible: true, documents: document });
  }

  useEffect(() => {
    setIsSmallHeader(true);
  }, [setIsSmallHeader]);

  //Syncronous effect to get data before render
  useEffect(() => {
    if (!document) {
      setLoading(true);
      api
        .getDocumentById(id, tipoDocId)
        .then((doc) => {
          setDocument({
            ...doc.data.Item,
            URLThumbnail: doc.data.Item.URLThumbnail.replace('~/', ''),
            URLArquivo: doc.data.Item.URLArquivo.replace('~/', ''),
          });
        })
        .catch((error) => {
          console.error(error);
          setResponseMsg({ isVisible: true, error: true, msg: error.message });
        })
        .finally(() => setLoading(false));
    }
  }, [id, setDocument, setLoading, setResponseMsg, document, tipoDocId]);

  if (isNaN(id)) return <Navigate to="/404" replace />;

  if (!document) return <Loading />;

  return (
    <>
      <section className="detail">
        <header className="detail__header">
          <h2>
            <span className="detail__nrdocumento">{document.NRDocumento}</span>
            {` - ${document.Titulo}`}
          </h2>
        </header>
        <h3 className="detail__version">{document.Versao}</h3>
        <Pdf id={id} thumbnail={document.URLThumbnail} tipoDoc={document.TipoDoc} title={document.Titulo} />
        <div className="detail__description">
          <h3>Descrição:</h3>
          <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(document.Descricao) }}></p>
        </div>
        <div className="detail__tags">
          <h3>Tags:</h3>
          <p>{document.Tag}</p>
        </div>
        <div className="detail__grouping">
          <h3>Classificação:</h3>
          <p>{document.Classificacao}</p>
        </div>
        <div className="detail__register">
          <h3>Data Cadastro:</h3>
          <p>{new Date(document.DTCadastro).toLocaleDateString()}</p>
        </div>
        <div className="detail__updateDate">
          <h3>Última Atualização:</h3>
          <p>{new Date(document.UpdateDate).toLocaleDateString()}</p>
        </div>
        <div className="detail__created">
          <h3>Criado por:</h3>
          <p>{document.CreatedBy}</p>
        </div>
        <div className="detail__modified">
          <h3>Editado por:</h3>
          <p>{document.ModifiedBy}</p>
        </div>
        <Button visual="history" onClick={handleHistory}>
          Histórico
        </Button>
        <Button visual="download" onClick={handleDownload}>
          Baixar
        </Button>
        <div className="detail__ndownload">Nº Downloads: {document.NDownload > 99 ? '99+' : document.NDownload}</div>
        <Button visual="related" onClick={handleTreeView} disabled={document.Documentos.length <= 0 && document.Links.length <= 0 ? true : false}>
          Documentos Relacionados
        </Button>
      </section>
      <Button
        visual="back"
        onClick={() => {
          window.history.length > 1 ? navigate(-1) : navigate('/');
        }}
      >
        Voltar
      </Button>
      {historyModal.isVisible && <HistoryModal />}
      {pdfModal.isVisible && <PdfModal />}
      {treeModal.isVisible && <TreeModal />}
    </>
  );
};

export default DetailPage;
